export default __webpack_public_path__ + "static/media/410.f4749799.gif";